(function () {
  var runner = document.querySelector('.christmas-reindeer-runner');
  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  var rerunTimer = null;

  if (!runner || reducedMotion.matches) return;

  function getNextDelay() {
    return Math.floor(60000 + Math.random() * 60001);
  }

  function runReindeer() {
    runner.classList.remove('is-running');
    void runner.offsetWidth;
    runner.classList.add('is-running');
  }

  function scheduleNextRun() {
    window.clearTimeout(rerunTimer);
    rerunTimer = window.setTimeout(runReindeer, getNextDelay());
  }

  runner.addEventListener('animationend', function (event) {
    if (event.animationName !== 'christmas-reindeer-run') return;

    runner.classList.remove('is-running');
    scheduleNextRun();
  });

  rerunTimer = window.setTimeout(runReindeer, 1000);
})();
